(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class NewProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations-new');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;

              var alsoLikeContainer = document.querySelector('.also-like-swiper');
              var alsoLikeSwiper;
              var swipeTiming = "400ms";
              let isAutoplayActive = true;
              let isLocked = false;
              let swiperRef;
              alsoLikeSwiper = new Swiper(".also-like-swiper", { 
                loop: true, 
                slidesPerView: 1.2,     
                spaceBetween: 6,
                speed:10000,
                autoplay: {
                  delay: 0, 
                  disableOnInteraction: false,
                }, 
                breakpoints: {
                  460: {
                    slidesPerView: 1.7      
                  },
                  600: {
                    slidesPerView: 2      
                  },
                  768: {
                    slidesPerView: 3      
                  },
                  1024: {
                    slidesPerView: 4
                  }
                }
              });  
              $('body').on('click', '.alsoLike-play-push .Play_Pause_button', function() {
                handlePauseButton();
              });
              function pauseCarousel() {
                if (!alsoLikeSwiper || !alsoLikeSwiper.autoplay.running) return;
                alsoLikeSwiper.autoplay.stop();
                alsoLikeSwiper.animating = false;
                alsoLikeSwiper.wrapperEl.style.transitionDuration = "0ms";
                const transform = alsoLikeSwiper.wrapperEl.style.transform.split(/\w+\(|\);?/);
                alsoLikeSwiper.wrapperEl.style.transform = getComputedStyle(alsoLikeSwiper.wrapperEl).transform;
                isAutoplayActive = false;
                setTimeout(() => {
                  alsoLikeSwiper.wrapperEl.style.transitionDuration = swipeTiming;
                  alsoLikeSwiper.wrapperEl.style.transform = `translate3d(${alsoLikeSwiper.getTranslate()}px, 0, 0)`;
                  const slide = alsoLikeSwiper.slides[alsoLikeSwiper.previousIndex];
                  const rect = slide ? slide.getBoundingClientRect() : null;
                  if (rect && (rect.x >= 0 || Math.abs(rect.left) <= rect.width / 2)) {
                      realignPausedCarousel(transform);
                  }
                }, 10);
              }
              function playCarousel() {
                if (!alsoLikeSwiper.autoplay.running) {
                  alsoLikeSwiper.autoplay.start();
                  isAutoplayActive = true;
                }
              }
              function handlePauseButton() {
                if (isAutoplayActive) {
                  isLocked = true;
                  pauseCarousel();
                  $(".also-like-swiper").addClass('push');
                } else {
                  isLocked = false;
                  playCarousel();
                  $(".also-like-swiper").removeClass('push');
                }
              }
              function realignPausedCarousel(transform) {
                alsoLikeSwiper.previousIndex--;
                alsoLikeSwiper.realIndex--;
                alsoLikeSwiper.activeIndex--;
                const parsed = transform[1].split(/,\s?/g).map(parseInt);
                const x = Math.floor(parsed[0]);
                const absX = Math.abs(x);
                const snapGrid = alsoLikeSwiper.snapGrid.map(e => Math.floor(Math.abs(e)));
                const index = snapGrid.indexOf(absX);
                alsoLikeSwiper.translate = -snapGrid[index - 1];
              }
              alsoLikeContainer.addEventListener('mouseenter', function() {
                if (alsoLikeSwiper && isAutoplayActive) {
                  pauseCarousel();
                  $(".also-like-swiper").addClass('push');
                }
              }); 
              alsoLikeContainer.addEventListener('mouseleave', function() {
                if (alsoLikeSwiper && !isAutoplayActive && !isLocked) {
                  playCarousel();
                  $(".also-like-swiper").removeClass('push');
                } 
              });
            }

            // if (html.querySelector('.swiper-slide')) {
            //   this.classList.add('product-recommendations--loaded');
            // }
              try{
                  if (typeof iWish !== 'undefined' ){
                        setTimeout(function() {
                        iWish.checkIwishColl();
                        }, 500)
                    }
                  }
                  catch(err){
                    //  console.log("",err);
                  }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }

  }

  customElements.define('product-recommendations-new', NewProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
